import React from "react";

const OurMission = () => (
  <section className="ls bio-parallax s-py-60 c-gutter-15">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center">
          <h3 className="special-heading text-center underline">
            Meet The Team
          </h3>
          <div className="divider-40"></div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 ">
          <div className="widget widget_slider">
            <div className="divider-40"></div>
            <div className="row top-right-nav">
              <div className="team-item vertical-item box-shadow col-md-6">
                <div className="item-media">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/dumebi.png`} alt="img" />
                </div>
                <div className="item-content">
                  <header className="entry-header text-center">
                    <h3>DUMEBI OTI</h3>
                    <h5>Co-Founder and Chief Executive Officer</h5>
                  </header>
                </div>
              </div>
              <div className="team-item vertical-item box-shadow col-md-6">
                <div className="item-media">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/adekemi.png`} alt="img" />
                </div>
                <div className="item-content">
                  <header className="entry-header text-center">
                    <h3>ADEKEMI ADEFEMI</h3>
                    <h5>Co-Founder and Chief Product Officer</h5>
                  </header>
                </div>
              </div>
            </div>
          </div>
          <div className="divider-45"></div>
        </div>
      </div>
    </div>
  </section>
);

export default OurMission;
